export const BUSINESS_TYPE_VALUES = Object.freeze({
  CRYPTO_EXCHANGE_OTC_LIQUIDITY_REMITTANCE_FX_MSB: "Crypto_Exchange_OTC_Liquidity_Remittance_FX_MSB",
  MSB_NO_CRYPTO: "MSB_No_Crypto",
  STOCK_BROKERAGE_NO_CRYPTO: "Stock_Brokerage_No_Crypto",
  STOCK_BROKERAGE_WITH_CRYPTO: "Stock_Brokerage_With_Crypto",
  FUND_FAMILY_OFFICE: "Fund_Family_Office",
  CORPORATE_HIGHER_LIMITS_NO_CLIENT_FUNDS: "Corporate_Higher_Limits_No_Client_Funds",
  OTHER: "Other",
});

const MSB_NO_CRYPTO_VALUES = new Set([
  BUSINESS_TYPE_VALUES.MSB_NO_CRYPTO,
  BUSINESS_TYPE_VALUES.STOCK_BROKERAGE_NO_CRYPTO,
]);

const MSB_WITH_CRYPTO_VALUES = new Set([
  BUSINESS_TYPE_VALUES.CRYPTO_EXCHANGE_OTC_LIQUIDITY_REMITTANCE_FX_MSB,
  BUSINESS_TYPE_VALUES.STOCK_BROKERAGE_WITH_CRYPTO,
]);

export const getBusinessTypeChecks = (selectedBusinesses = []) => {
  const values = Array.isArray(selectedBusinesses) ? selectedBusinesses : [];

  return {
    msbCheck: values.some((value) => MSB_NO_CRYPTO_VALUES.has(value)),
    cryptoExchangeCheck: values.some((value) => MSB_WITH_CRYPTO_VALUES.has(value)),
    fundAndFamilyCheck: values.includes(BUSINESS_TYPE_VALUES.FUND_FAMILY_OFFICE),
    accountUpgradeCheck: values.includes(BUSINESS_TYPE_VALUES.CORPORATE_HIGHER_LIMITS_NO_CLIENT_FUNDS),
  };
};
